import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { IHeadboardInforme2024Props } from '../headboardInforme2024';
import { customTitle } from '../../../../utils/customTitle';

function headboardInforme2024Adapter(data: any): IHeadboardInforme2024Props {
    return {
        title: data.tituloPrincipal ? customTitle(data.tituloPrincipal) : '',
        desc: data.descripcion ? documentToReactComponents(JSON.parse(data.descripcion.raw)) : '',
        bgImage: data.imagenHeader ? data.imagenHeader.file.url : '',
        bgImageMobile: data.imagenesArboles ? data.imagenesArboles[0].file.url : '',
        btnRedirect: data.redireccionBoton ? data.redireccionBoton : '',
        btnLabel: data.tituloBoton ? data.tituloBoton : 'Conocer más'
    };
}

export default headboardInforme2024Adapter;
